import { Modal, ModalOverlay, ModalContent, Flex, Image, List, Text, Box, useToast } from '@chakra-ui/react'
import { Button as UbiButton, InlineNotification } from '@ubirider/pick-component-library'
import { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getBillingInfo } from '../../../../../../api/billing'
import { AuthContext } from '../../../../../../AuthProvider'
import { changeInvoice } from '../../../../../../api/invoice'
import NifComponent from './components/NifComponent/NifComponent'

import infoIcon from '../../../../../../assets/information_purple.svg'
import closeButton from '../../../../../../assets/cross.svg'
import grayPlus from '../../../../../../assets/plus_gray.svg'
import checkWhiteIcon from '../../../../../../assets/check_circle_white.svg'
import closeWhiteIcon from '../../../../../../assets/cross_white_24.svg'
import arrowBackIcon from '../../../../../../assets/arrow_left.svg'
import { useBilling } from '../../../../../../context/DataProvider'

export function SelectBillingModal({ onOpenBM, onOpen, onClose, isOpen, trips }) {
  const { t } = useTranslation()
  const windowSize = useRef([window.innerWidth, window.innerHeight])

  const { billing } = useBilling()

  const [loading, setLoading] = useState(false)
  const [checkedBilling, setCheckedBilling] = useState({})

  useEffect(() => {
    setCheckedBilling(null)
  }, [onOpen])

  const handleToast = () => {
    toastIdRef.current = toast({
      position: 'top',
      duration: 5000,
      isClosable: true,
      render: () => (
        <Box
          alignItems='center'
          color='white'
          bg='#01AE70'
          border='1px solid #067F5B'
          boxShadow='box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05)'
          borderRadius='4px'
        >
          <Flex justifyContent='space-between' gap='16px' padding='16px'>
            <Image src={checkWhiteIcon} />
            <Text fontSize='14px' fontWeight='600'>
              {t('travel_history.tax_id_changed')}
            </Text>
            <Image cursor='pointer' onClick={close} src={closeWhiteIcon} />
          </Flex>
        </Box>
      ),
    })
  }

  const changeTaxID = async () => {
    try {
      setLoading(true)
      for (const trip of trips) {
        const res = await changeInvoice(trip.invoices[trip.invoices.length - 1].saleID, trip.date, checkedBilling)
        const link = document.createElement('a')
        link.href = res.invoice.link
        document.body.appendChild(link)
        link.click()
        link.download = res.invoice.invoiceName
        document.body.removeChild(link)
        setLoading(false)
        onClose()
        handleToast()
      }
    } catch (error) {
      setLoading(false)
      console.error(error.message)
    }
  }

  const toast = useToast()
  const toastIdRef = useRef()

  function close() {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      trapFocus={false}
      closeOnOverlayClick={false}
      autoFocus={false}
      size={{ sm: 'full', md: 'full', lg: 'xl', xl: 'xl' }}
      isCentered={windowSize.current[0] >= 960}
    >
      <ModalOverlay />
      <ModalContent padding={{ sm: '16px 24px', md: '16px 24px', lg: '36px', xl: '36px' }}>
        <Flex direction='column' flex='1' gap='24px' mt={{ sm: '67px', md: '67px', lg: '0px', xl: '0px' }}>
          {windowSize.current[0] < 960 && (
            <Flex alignItems='flex-start'>
              <UbiButton
                onClick={onClose}
                style='ghost'
                type='neutralLight'
                label={t('authentication.back')}
                leftIconProps={{ src: arrowBackIcon }}
                css={{ paddingLeft: '0' }}
              />
            </Flex>
          )}

          <Flex direction='row' justifyContent='space-between' alignItems='center'>
            <Text fontWeight='700' fontSize='24px' flex='1'>
              {t('travel_history.select_billing_information')}
            </Text>
            <Flex
              display={{ sm: 'none', md: 'none', lg: 'flex', xl: 'flex' }}
              as='button'
              onClick={onClose}
              type='button'
            >
              <Image src={closeButton} />
            </Flex>
          </Flex>

          <InlineNotification type='secondary' message={t('travel_history.invoice_change_time_alert')} />

          <Flex direction='column' gap='8px'>
            <List>
              {billing.map((profile, index) => (
                <NifComponent
                  key={index}
                  info={profile}
                  isChecked={checkedBilling?.nif === profile.nif}
                  onChange={() => {
                    setCheckedBilling(checkedBilling?.nif === profile.nif ? null : profile)
                  }}
                />
              ))}
            </List>
            <UbiButton
              onClick={() => {
                onOpenBM()
                onClose()
              }}
              style='ghost'
              type='secondary'
              leftIconProps={{ src: grayPlus }}
              label={t('billing_information.add_new_billing_information')}
            />
          </Flex>
          <UbiButton
            onClick={changeTaxID}
            loading={loading}
            disabled={!checkedBilling}
            style='solid'
            type='secondary'
            label={t('travel_history.select')}
            css={{ alignSelf: 'stretch' }}
          />
        </Flex>
      </ModalContent>
    </Modal>
  )
}
